import {
  RELEVANCE_NAME_TO_TRANSLATION_KEY,
  RELEVANCE_SCORE_TO_NAME,
} from '../../../constants/relevance';

export const getRelevanceScoreTranslationKey = (score: number): string => {
  const relevanceName = RELEVANCE_SCORE_TO_NAME[score];
  const translationKey = RELEVANCE_NAME_TO_TRANSLATION_KEY[relevanceName];
  return `common:recordings.relevance-score.${translationKey}`;
};

export const getRelevanceScoreTranslationKeyByName = (relevanceName: string): string => {
  const translationKey = RELEVANCE_NAME_TO_TRANSLATION_KEY[relevanceName];
  return `common:recordings.relevance-score.${translationKey}`;
};
